'use client'

import React from 'react'

import {
  Breadcrumbs,
  Footer,
  Header,
  Main,
  PageWrapper,
} from 'Components/Blocks'
import {
  FastToMarketSection,
  SectorsWeEngineerForImpactSection,
  TechWeBuildOnTiWinSection,
} from 'Components/Sections'

import { LANDING_INLINE_PADDINGS } from 'Constants/Landing'
import { EXPERTISE } from 'Constants/Paths'

function ExpertisePage() {
  return (
    <PageWrapper>
      <Header />

      <Main>
        <Breadcrumbs
          paths={[{ caption: 'Expertise', href: EXPERTISE }]}
          pt={160}
          px={LANDING_INLINE_PADDINGS}
        />

        <FastToMarketSection pb={17} pt={9} />

        <SectorsWeEngineerForImpactSection py={11} />

        <TechWeBuildOnTiWinSection py={64} />
      </Main>

      <Footer />
    </PageWrapper>
  )
}

export default ExpertisePage
